<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="emSicCustomizedDiagramPieceCdpResultTable" class="content d-flex flex-row">
                <div class="col">
                    <div class="card my-1">
                        <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                             data-parent="#accordionResult">
                            <div class="card-body">
                                <em-table :entity="modelName"
                                          :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                          :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                          :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                          ref="emTable" exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                          @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                          @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow"></em-table>
                            </div>
                        </div>
                    </div>
                </div>
                <drawer-handler ref="drawer" v-if="imgUrl" class="col-6" :open-width="28">
                    <customized-diagram-view ref="mapView" :img-url="imgUrl" class="w-100 h-100" :zoom="0.95"
                                             scale-able
                                             @pieceClick="inputPieceCodeToNewRow"
                                             @imgLoadFailed="$refs.drawer.toggle(false)"></customized-diagram-view>
                </drawer-handler>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
// Author lgq
// Date 2022-02-23 13:53:32

import emCommonListMixin from "@/mixin/em/common/list";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import DrawerHandler from "@/components/echarts-part/CalendarShift/cells/stuffs/DrawerHandler";
import CustomizedDiagramView from "@/components/LayoutMaps/openLayers/CustomizedDiagramView";

export default {
    name: "emSicCustomizedDiagramPieceCdpListView",
    components: {CustomizedDiagramView, DrawerHandler},
    mixins: [emCommonListMixin, emCustomVuexMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        routerContent() {
            return this.$store.state.routeStore.content;
        }
    },
    data() {
        return {
            styleJson: undefined,
            imgUrl: ""
        }
    },
    mounted() {
        let query = this.$route.query;
        if (query.imgUrl) this.imgUrl = query.imgUrl;
        if (this.routerContent.styleJson) this.styleJson = JSON.parse(this.routerContent.styleJson);
        let mapJson = this.routerContent.mapJson;
        if (mapJson) {
            this.$nextTick(() => {
                if (this.styleJson) {
                    this.$refs.mapView.setSomeJson(JSON.parse(mapJson), this.styleJson.pieceStyle);
                } else {
                    this.$refs.mapView.setMapJson(JSON.parse(mapJson));
                }
            });
        } else {
            this.imgUrl = null;
        }
        this.registerInputConfig();
    },
    methods: {
        inputPieceCodeToNewRow(piece) {
            this.$refs.emTable.setNewRowValue('cdpPieceCode', piece.name);
        },
        registerInputConfig() {
            let config = [
                {
                    label: 'URL地址',
                    key: 'url',
                    type: 'string'
                },
                {
                    label: 'API地址',
                    key: 'api',
                    type: 'string'
                },
                {
                    label: 'SQL语句',
                    key: 'sql',
                    type: 'string'
                },
                {
                    label: '结果取值字段',
                    key: 'responseBodyField',
                    type: 'string'
                },
                {
                    label: '查询参数',
                    key: 'queryParam',
                    type: 'string'
                },
                {
                    label: '查询结果',
                    key: 'queryResult',
                    type: 'string'
                },
                {
                    label: '小数点保留位数',
                    key: 'numberFixed',
                    type: 'number'
                },
            ];
            this.$store.dispatch('jsonInputConfigStore/registerConfig', {
                entityName: this.modelName,
                fieldName: 'cdpProperties',
                config: config
            })
        },
    },
};
</script>